module.exports = __webpack_public_path__ + "static/use-case-4-content-4-93584d8a62493a489721e632f403231c.png";